import React from 'react';
import { Badge, Button } from '../';
import './DragSelectedItem.scss';

const MAX_STACK_DEPTH = 3;

/**
 * DragSelectedItem - Visual indicator of one or more items being dragged.
 */
export const DragSelectedItem = ({ label, count = 1 }) => {
    const extraCount = count - 1;
    const stackDepth = Math.min(extraCount, MAX_STACK_DEPTH);

    return (
        <div className="drag-selected-item">
            <Badge count={extraCount > 0 ? `+${extraCount}` : 0} className="drag-selected-item__badge">
                {/* Stacked buttons behind the main one, bottom to top */}
                {Array.from({ length: stackDepth }).map((_, i) => {
                    const depth = stackDepth - i;
                    return (
                        <Button
                            key={i}
                            type="primary"
                            className="drag-selected-item__button drag-selected-item__button--stacked"
                            style={{ top: depth * 4, opacity: 1 - depth * 0.25, zIndex: i }}
                        >
                            {label}
                        </Button>
                    );
                })}
                {/* Main (top) button */}
                <Button
                    type="primary"
                    className="drag-selected-item__button drag-selected-item__button--main"
                    style={{ zIndex: stackDepth + 1 }}
                >
                    {label}
                </Button>
            </Badge>
        </div>
    );
};
